import Input, { InputProps } from './Input';

export type { InputProps };
export default Input;
